var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('big-picture'),_c('mt-basics'),_c('we-service'),_c('product-system'),_c('we-advantage'),_c('home-new'),_c('cooperative-partner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }